import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';
import Header from './Header';
import Footer from './Footer';
import AgeGate from '../AgeGate';
import SearchOverlay from '../SearchOverlay';
import CartDrawer from '../CartDrawer';
import CompareTray from '../CompareTray';

export default function Layout() {
  const [searchOpen, setSearchOpen] = useState(false);
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAF8]">
      <Header onSearch={() => setSearchOpen(true)} />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <AgeGate />
      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
      <CartDrawer />
      <CompareTray />
      <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 4, fontFamily: 'JetBrains Mono, monospace', fontSize: 12 } }} />
    </div>
  );
}
